angular.module('tgaAdmin')
  .service('userService', [
    '$http', '$q', '$cookies', '$location', 'authService', 'localStorageService', 'envService',
    'domainService', 'gameService', 'settingsService', 'tzService', 'notificationService',
    '$window', 'bannerNotificationsService', '$rootScope', '$log',
    function (
      $http, $q, $cookies, $location, authService, localStorageService, envService,
      domainService, gameService, settingsService, tzService, notificationService,
      $window, bannerNotificationsService, $rootScope, $log,
    ) {
      const serverAddress = envService.read('serverAddress');

      const storageKey = 'user';
      const redirectKey = 'tgaRedirect';

      let user = null;

      function getCurrentUser() {
        return $http({
          method: 'GET',
          url: `${serverAddress}user`,
          params: {
            current_user: true,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUser(userId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}user/${userId}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUsers(params) {
        return $http({
          method: 'GET',
          url: `${serverAddress}user`,
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUsersList() {
        return $http({
          method: 'GET',
          url: `${serverAddress}user/list`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getGameAccessUsers(gameId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}user/access/${gameId}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUserGameAccess(userId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}user/access/games/${userId}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getUserData() {
        if (!user) {
          user = localStorageService.get(storageKey);
        }
        return user;
      }

      function checkUserType(userTypes) {
        const userData = getUserData();

        if (userData && userData.user_type) {
          return userTypes.indexOf(userData.user_type) !== -1;
        }

        return false;
      }

      function setUser(newUser) {
        user = newUser;
        localStorageService.set(storageKey, user);

        tzService.setUserTimezone(user?.timezone);
      }

      function isTwoFactor() {
        return authService.getAuthentication().twoFactor;
      }

      function twoFactorRememberEnabled() {
        return authService.getAuthentication().twoFactorRemember;
      }

      function isLoggedIn() {
        // Check if user is redirecting from a different subdomain
        const authCookie = $cookies.getObject(redirectKey);
        if (authCookie) {
          const auth = authService.clearAuthentication();
          auth.isAuth = true;
          auth.username = authCookie.username;
          auth.token = authCookie.key;
          auth.userId = authCookie.id;

          authService.setAuthentication(auth);
          authService.setDeviceToken(authCookie.two_factor_device);

          $cookies.remove(redirectKey, {
            path: '/',
            domain: domainService.base,
          });

          setUser(authCookie);
          getUser(auth.userId).then(
            (u) => {
              setUser(u);
              $rootScope.$broadcast('refreshDomains');
            },
          );
        }

        // todo think about the check that is required here
        if (twoFactorRememberEnabled() && authService.getDeviceToken() === null) {
          authService.clearAuthentication();
        }

        return authService.getAuthentication().isAuth;
      }

      function addUser(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}user`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateUser(data, currentUser) {
        data.domain = domainService.domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}user`,
          data,
        }).then(
          (response) => {
            if (currentUser) {
              setUser(response.data);
            }

            return response.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function updateUserPassword(data) {
        const authentication = authService.getAuthentication();
        data.domain = domainService.domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}user/password`,
          data,
        }).then(
          (response) => {
            authentication.token = response.data;
            authService.setAuthentication(authentication);
            return response.data
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteUser(userId) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/delete`,
          data: {
            domain: domainService.domain,
            user_id: userId,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteUserAccess(gameAccessId) {
        return $http({
          method: 'DELETE',
          url: `${serverAddress}user/permissions/${gameAccessId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function logout() {
        authService.clearAuthentication();
        setUser(null);
        domainService.destroy();
        gameService.destroy();
        settingsService.destroy();
        notificationService.destroy();
        bannerNotificationsService.destroy();
      }

      function loginCommon(data) {
        const authentication = authService.clearAuthentication();

        return $http({
          method: 'POST',
          url: `${serverAddress}user/login/common`,
          data: {
            email: data.username,
            password: data.password,
            access_token: data.access_token,
            rt: data.rt,
          },
        }).then(
          (response) => {
            // Common login can't be used when SSO is turned on for the domain
            if (response.data.sso && response.data.redirect) {
              $window.location = response.data.redirect;
              return;
            }
            authentication.isAuth = true;
            authentication.username = data.username;
            authentication.token = response.data.key;
            authentication.userId = response.data.id;
            authentication.remember = data.remember;
            authService.setAuthentication(authentication);
            // eslint-disable-next-line consistent-return
            return response.data;
          },
          (error) => {
            logout();
            throw error.data;
          },
        );
      }

      function loginTwoFactor(data) {
        const authentication = authService.getAuthentication();
        if (data.two_factor_remember) {
          const deviceGuid = uuidv4();
          authService.setDeviceToken(deviceGuid);
        }

        return $http({
          method: 'POST',
          url: `${serverAddress}user/login/2fa`,
          data: {
            email: authentication.username,
            resend: data.resend,
            two_factor_secret: data.two_factor_secret,
            two_factor_remember: data.two_factor_remember,
            domain: domainService.domain,
            token: authentication.token,
            deviceToken: authService.getDeviceToken(),
          },
        }).then(
          () => {
            authentication.isAuth = true;
            authentication.twoFactor = true;
            authentication.twoFactorRemember = data.two_factor_remember;
            authService.setAuthentication(authentication);

            return getUser(authentication.userId).then((currentUser) => {
              setUser(currentUser);
              return currentUser;
            });
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function login(data) {
        const authentication = authService.clearAuthentication();
        let deviceToken = authService.getDeviceToken();

        return $http({
          method: 'POST',
          url: `${serverAddress}user/login`,
          data: {
            email: data.username,
            password: data.password,
            domain: domainService.domain,
            token: data.token,
            deviceToken,
          },
        }).then(
          (response) => {
            authentication.username = data.username;
            authentication.token = response.data.key;
            authentication.userId = response.data.id;
            authentication.remember = data.remember;
            authentication.twoFactor = response.data.two_factor_enabled;
            authentication.twoFactorRemember = response.data.two_factor_remember;
            deviceToken = response.data.device_token;

            if (response.data.two_factor_enabled && !response.data.two_factor_remember) {
              authService.setAuthentication(authentication);
              authService.clearDeviceToken();
              return authentication;
            }

            authentication.isAuth = true;
            authService.setAuthentication(authentication);
            authService.setDeviceToken(deviceToken);

            return getUser(authentication.userId).then((currentUser) => {
              setUser(currentUser);
              return currentUser;
            });
          },
          (error) => {
            logout();
            throw error.data;
          },
        );
      }

      function forgot(email) {
        authService.clearAuthentication();

        return $http({
          method: 'POST',
          url: `${serverAddress}user/forgot`,
          data: {
            email,
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function reset(data) {
        authService.clearAuthentication();

        return $http({
          method: 'POST',
          url: `${serverAddress}user/reset`,
          data: {
            token: data.token,
            password: data.password,
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function checkEmail(email, allow_player) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/check`,
          data: {
            email,
            allow_player,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function registerUser(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/register`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addDomain(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/domain`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addPaymentMethod(token) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/payment`,
          data: {
            token,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function ssoRegister(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/sso`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function sendInvitation(userId) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}user/invitation/${userId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getInvitation(token) {
        return $http({
          method: 'GET',
          url: `${serverAddress}user/invitation`,
          params: {
            domain: domainService.domain,
            token,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function acceptInvitation(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}user/invitation`,
          data,
        }).then(
          (response) => {
            const authentication = authService.clearAuthentication();
            authentication.isAuth = true;
            authentication.username = response.data.username;
            authentication.token = response.data.key;
            authentication.userId = response.data.id;

            authService.setAuthentication(authentication);

            return getUser(authentication.userId).then((currentUser) => {
              setUser(currentUser);
              return currentUser;
            });
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function hasAccess(key) {
        if (user.permissions.has_access) {
          for (let i = 0; i < user.permissions.has_access.length; i++) {
            if (user.permissions.has_access[i][key]) {
              return true;
            }
          }
        }

        return false;
      }

      function hasLimit(u, key) {
        if (u.permissions.has_limit && u.permissions.has_limit[key]) {
          if (u.permissions.has_limit[key].length) {
            return true;
          }
        }

        return false;
      }

      function addUserGameAccess(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/permissions`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function assignUserToDomains(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}user/admin_assign`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function setData(key, value) {
        if (_.isObjectLike(key)) {
          _.extend(user.data, key);
        } else {
          user.data[key] = value;
        }

        $http({
          method: 'POST',
          url: `${serverAddress}user/data`,
          data: user.data,
        }).then(
          (response) => {
            setUser(user);
            return response.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function getData(key) {
        if (user && user.data && key) {
          $log.debug('userService.getData', user.data);
          return $q.resolve(user.data[key]);
        }

        return $http({
          method: 'GET',
          url: `${serverAddress}user/data`,
        }).then(
          (response) => {
            user.data = response.data;
            setUser(user);
            return response.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        isLoggedIn,
        isTwoFactor,
        twoFactorRememberEnabled,
        getUser,
        getCurrentUser,
        getUsers,
        getUsersList,
        getUserData,
        checkUserType,
        setUser,
        addUser,
        updateUser,
        updateUserPassword,
        deleteUser,
        login,
        loginCommon,
        loginTwoFactor,
        logout,
        forgot,
        reset,
        checkEmail,
        registerUser,
        addPaymentMethod,
        ssoRegister,
        sendInvitation,
        getInvitation,
        acceptInvitation,
        addDomain,
        hasLimit,
        hasAccess,
        addUserGameAccess,
        getGameAccessUsers,
        deleteUserAccess,
        getUserGameAccess,
        assignUserToDomains,
        setData,
        getData,
      });
    }]);
